import React from "react";
import { Outlet } from "react-router";

import Header from "../components/Header";
import GovernmentBanner from "../components/GovernmentBanner";
import SidebarBusinessMain from "../components/Sidebar/businesssidebar";
import SidebarInternalMain from "../components/Sidebar/internalsidebar";
import Footer from "../components/Footer/Footer";

import "./AuthLayout.css";
import "../pages/Internal/Stylesheet/Internal.css";

const AuthLayout = () => {
  const userType = localStorage.getItem("userType");

  const isBusinessUser = userType === "Business";
  const isInternalUser = userType === "Internal";
  const hasSidebar = isBusinessUser || isInternalUser;
  
  const layoutClassName = [
    "dga-layout",
    hasSidebar
      ? "dga-layout--with-sidebar"
      : "dga-layout--without-sidebar",
    isInternalUser ? "dga-layout--internal" : "",
  ]
  .filter(Boolean)
  .join(" ");
  
  return (
    <div className="dga-app" dir="rtl">
      <GovernmentBanner />

      <Header />

      <div className={layoutClassName}>
        
        {isBusinessUser && <SidebarBusinessMain />}

        {isInternalUser && <SidebarInternalMain />}

        <main className="dga-auth-content">
          <Outlet />
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default AuthLayout;